import initMenuMobile from './menu';

// require('../bootstrap');
/*
setTimeout(() => {
  window.carousel = require('bootstrap/js/src/carousel');
}, 5000);
*/

//* MOBILE QUERY MATCH */
const mql = window.matchMedia('(max-width: 1180px)');

const menuDom = document.querySelector('.main__header');
// const menuA = menuDom.querySelector('.menu__A');
// const menuA = document.querySelector('.section__hello .main-nav');
const carrouselDom = document.querySelector('.carousel');

//* HIDDEN MESSAGE COMPANIES BTN */
const companiesBtn = document.querySelector('.section__companies button');
const companiesHidden = document.querySelector('.section__companies_hidden');
const faqElems = document.querySelectorAll('.section__faq_list li>div');
const benefitsBtn = document.querySelector('.section__benefits button');
const benefitsHidden = document.querySelector('.section__benefits_hidden');
let menuFlag = true;
let scrollHeightMax = 0;

/**
 * showMenuScroll
 * * Check if the user is in mobile or desktop
 * * If desktop, show the menu on Scroll
 * ? Maybe refactor ?
 * TODO: outside home page there is no on scroll
 */
const showMenuScroll = () => {
  scrollHeightMax = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0,
  );
  window.onscroll = (e) => {
    console.log('scrolled');
    //* MOSTRAR MENU FIXED */
    if (window.scrollY >= scrollHeightMax) {
      if (menuFlag) {
        menuA.classList.add('show');
        console.log('menutop showed');
        menuFlag = false;
      }
    } else if (!menuFlag) {
      menuA.classList.remove('show');
      console.log('menutop hidden');
      menuFlag = true;
    }
  };
};
const changeMobileColor = () => {
  scrollHeightMax = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0,
  );
  window.onscroll = (e) => {
    console.log('scrolled');
    //* MOSTRAR MENU FIXED */
    if (window.scrollY >= scrollHeightMax) {
      if (menuFlag) {
        menuA.classList.add('colored');
        console.log('menutop showed');
        menuFlag = false;
      }
    } else if (!menuFlag) {
      menuA.classList.remove('colored');
      console.log('menutop hidden');
      menuFlag = true;
    }
  };
};
/**
 * init
 * * Initialize All Methods
 * TODO: Refactor
 */
const init = () => {
  // Desactivado showMenuScroll - ahora usamos navbar-comparamos sticky
  // if (!mql.matches) {
  //   console.log('desktop'); showMenuScroll();
  // } else {
  //   showMenuScroll();
  //   // changeMobileColor();
  // }

  //* HIDDEN MESSAGE SHOW */
  if (companiesBtn) {
    companiesBtn.addEventListener('click', (e) => {
      const btn = e.target;
      companiesHidden.classList.toggle('show');
      if (companiesHidden.classList.contains('show')) {
        btn.innerText = 'Mostrar menos';
      } else {
        btn.innerText = 'Dime más sobre estas compañías';
      }
    });
  }

  if (benefitsBtn) {
    benefitsBtn.addEventListener('click', (e) => {
      const btn = e.target;
      benefitsHidden.classList.toggle('show');
      if (benefitsHidden.classList.contains('show')) {
        btn.innerText = 'Mostrar menos';
      } else {
        btn.innerText = 'Dime Más';
      }
    });
  }
  if (faqElems) {
    [...faqElems].forEach((faqi) => {
      faqi.addEventListener('click', (e) => {
        const faq = e.target;
        faq.classList.toggle('show');
      });
    });
  }
  console.log('init');
};

init();
